import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component.js"
import useCreatedEvent from "@kaspernj/api-maker/build/use-created-event.js"

const PropTypes = require("prop-types")
const propTypesExact = require("prop-types-exact")

class EventCreated extends ShapeComponent {
  static defaultProps = {
    active: true
  }

  static propTypes = propTypesExact({
    active: PropTypes.bool,
    debounce: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.number
    ]),
    modelClass: PropTypes.func.isRequired,
    onCreated: PropTypes.func.isRequired
  })

  setup() {
    // Optional props are read from this.props (where useShapeHook has
    // merged defaultProps) because the strict this.p proxy throws on
    // props that were not passed.
    const {active, debounce, modelClass, onCreated} = this.props

    // ShapeComponent's setup() is a documented React hook location
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useCreatedEvent(modelClass, onCreated, {active, debounce})
  }

  render() {
    return null
  }
}

export default React.memo(shapeComponent(EventCreated))
